export const createMarketersListSlice = (set) => ({
  marketers: {
      loading: false,
      saleLoading: false,
      data: [],
      single: {},
      // sales: [],
      // boughts: [],
      // userAgentWage: [],
      selectedItem: null,
      businesses: [],
      filtered: [],
      filteredItem: "",
      filterMarketers: [],
      promoters: [],
      totalMarketers: 1
  },
  Marketers_LOADING: (loading) => set(state => ({ marketers: { ...state.marketers, loading } })),
  // SALE_LOADING: (saleLoading) => set(state => ({ marketers: { ...state.marketers, saleLoading } })),
  GET_SINGLE_Marketer: (user) => set(state => ({ marketers: { ...state.marketers, single: user } })),
  GET_USER_BUSINESSES: (businesses) => set(state => ({ marketers: { ...state.marketers, businesses, loading: false } })),
  GET_ALL_Marketers: (marketers) => set(state => ({ marketers: { ...state.marketers, data: marketers, filtered: marketers, loading: false } })),
  GET_FILTER_Marketers: (filterMarketers) => set(state => ({ marketers: { ...state.marketers, filterMarketers, loading: false } })),
  GET_PROMOTERS: (promoters) => set(state => ({ marketers: { ...state.marketers, promoters, loading: false } })),
  // GET_USER_SALE: (sales) => set(state => ({ marketers: { ...state.marketers, sales, loading: false } })),
  // GET_USER_AGENT_WAGE: (userAgentWage) => set(state => ({ marketers: { ...state.marketers, userAgentWage } })),
  FILTERED_ITEM: (filteredItem) => set(state => ({ marketers: { ...state.marketers, filteredItem } })),
  FILTER_Marketers: (filtered) => set(state => ({ marketers: { ...state.marketers, filtered } })),
  SET_TOTAL_Marketers: (totalMarketers) => set(state => ({ marketers: { ...state.marketers, totalMarketers } }))

});  